import { connect } from 'react-redux';
import {
  getFilteredPtoList,
  getFilterIdentifierCount,
  getFilterOptions,
  getNumberFuturePtos,
} from '../../store/openOrder';

import DesktopButtons from './DesktopButtons';

const mapStateToProps = state => ({
  filterCount: getFilterIdentifierCount(state),
  filterOptions: getFilterOptions(state),
  numberFuturePtos: getNumberFuturePtos(state),
  openPtoList: getFilteredPtoList(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopButtons);
